export const TRAFFIC_SUM_TRESHOLD = 500;
